module.exports = __webpack_public_path__ + "static/media/Logo.2b52dc4e.png";